import type { DotProps } from "recharts";
import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.4;
  }
  100% {
    transform: scale(3);
    opacity: 0;
  }
`;

const AnimatedDotWrapper = styled.g`
  .pulse-ring {
    animation: ${pulseAnimation} 1.2s ease-out infinite;
    -webkit-animation: ${pulseAnimation} 1.2s ease-out infinite;
    /* transform-originを円の中心座標に設定 */
    transform-origin: var(--cx) var(--cy);
    -webkit-transform-origin: var(--cx) var(--cy);
  }
`;

export interface AnimatedDotProps extends DotProps {
  color?: string;
}

export const AnimatedDot = ({ cx, cy, fill, color }: AnimatedDotProps) => {
  if (cx === undefined || cy === undefined) return null;

  const dotColor = color || fill || "#000";

  return (
    <AnimatedDotWrapper
      style={
        {
          "--cx": `${cx}px`,
          "--cy": `${cy}px`,
        } as React.CSSProperties
      }
    >
      <circle className="pulse-ring" cx={cx} cy={cy} r={4} fill={dotColor} opacity={0.4} />
      <circle cx={cx} cy={cy} r={4} fill={dotColor} />
    </AnimatedDotWrapper>
  );
};
